export default __webpack_public_path__ + "static/media/mat.fa387612.svg";